import { render, staticRenderFns } from "./reportingList.vue?vue&type=template&id=85e2a998&scoped=true&"
import script from "./reportingList.vue?vue&type=script&lang=js&"
export * from "./reportingList.vue?vue&type=script&lang=js&"
import style0 from "./reportingList.vue?vue&type=style&index=0&id=85e2a998&scoped=true&lang=css&"
import style1 from "./reportingList.vue?vue&type=style&index=1&id=85e2a998&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e2a998",
  null
  
)

export default component.exports